class Tenant {
    constructor(data = {}) {
        const { uuid, name, tenantId, tenantName, tenantType } = data

        this.UUID = uuid || tenantId || null
        this.name = name || tenantName || ''
        this.tenantType = tenantType || ''
    }
}

export default Tenant
